export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14470.7ac2e31a.jpg";